module.exports = __webpack_public_path__ + "img/flag-checkered.424d90af.svg";